import type { FaireProductEntity } from "../../entity_types/product";

export const p_72xxj27lh3: FaireProductEntity = {
  token: "p_72xxj27lh3",
  type: "product",
  name: "Grateful Dead Dancing Bear Plush Toy",
  brandToken: "b_a9b1eaal9m",
  brandName: "Daphyl's LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/b38fe0eaffc7eb09ad2fcd3b4bd65846e9cd40bf55bbaebe5bd57243535da2aa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27e12a0fb4abd58f2e7012ffcc87f521a6156b46c68fcb368624e9646474d28f.jpeg",
    "https://cdn.faire.com/fastly/e31dcb07df7e02bf90febba831104e6ee595f80bbc26ce96fb9933785bd8f1cf.jpeg",
    "https://cdn.faire.com/fastly/6a580a82bfbc18dcc05d30fe95ef034c84168e6c30f48a30f5e92e8c3ebf97b6.jpeg",
    "https://cdn.faire.com/fastly/7b2121b8717ec1113236f41138a1399e70b7520a4567eb98506f7b68774657cc.jpeg",
    "https://cdn.faire.com/fastly/3821a5fb6c566d6ae7164320d1140aac8f3f01cd74451dd0a3128b4fd15b1901.jpeg",
    "https://cdn.faire.com/fastly/ba4db075ba05e6e397f5d00dfb620e1babdea2b685aa619c31054305bfb4a859.jpeg",
    "https://cdn.faire.com/fastly/334fc354d60e329cb4c08ffe640c33c405e18a7c9b24b9237004ad3e787205a6.jpeg",
    "https://cdn.faire.com/fastly/5018e8c8345f265ce7641227cb44dadf69dfefe201c749ccce861f6d10cc264c.jpeg",
  ],
  priceDollars: 10.82,
  description:
    "Delight your little one with the Grateful Dead Dancing Bear Plush Toy from Daphyls. Inspired by the classic, peace-loving band, this adorable bear features a rattling head, squeaking belly, and crinkle paper feet. 40 Assorted colors.\nWeight 7.5Ibs\nHeight 66.5''.\n0 months +.",
  tags: [],
  msrpDollars: 21.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:11.166Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
